import { __extends } from "tslib";
import { ImageTexture2D } from '@awayjs/renderer';
var DepthTexture2D = /** @class */ (function (_super) {
    __extends(DepthTexture2D, _super);
    function DepthTexture2D(image) {
        if (image === void 0) { image = null; }
        return _super.call(this, image) || this;
    }
    Object.defineProperty(DepthTexture2D.prototype, "assetType", {
        /**
         *
         * @returns {string}
         */
        get: function () {
            return DepthTexture2D.assetType;
        },
        enumerable: true,
        configurable: true
    });
    DepthTexture2D.assetType = '[texture DepthTexture2D]';
    return DepthTexture2D;
}(ImageTexture2D));
export { DepthTexture2D };
import { ShaderBase } from '@awayjs/renderer';
import { _Shader_DepthTexture } from './DepthTextureCube';
ShaderBase.registerAbstraction(_Shader_DepthTexture, DepthTexture2D);
